const UPDATE_BIN_REQUEST = 'UPDATE_BIN_REQUEST';
const UPDATE_BIN_SUCCESS = 'UPDATE_BIN_SUCCESS';
const UPDATE_BIN_FAILURE = 'UPDATE_BIN_FAILURE';

const GET_BIN_REQUEST = 'GET_BIN_REQUEST';
const GET_BIN_SUCCESS = "GET_BIN_SUCCESS";
const GET_BIN_FAILURE = "GET_BIN_FAILURE";

const TRIGGER_RESET_BIN_DATA = "TRIGGER_RESET_BIN_DATA";
const RESET_BIN_DATA = "RESET_BIN_DATA";

export {
    UPDATE_BIN_REQUEST,
    UPDATE_BIN_SUCCESS,
    UPDATE_BIN_FAILURE,
    GET_BIN_REQUEST,
    GET_BIN_SUCCESS,
    GET_BIN_FAILURE,
    RESET_BIN_DATA,
    TRIGGER_RESET_BIN_DATA
}